import type from './Measurment.type';

const initialState = {
  documentList: [],
  orderGradingGroups: [],
  sampleSizeData: [],
};

const measurmentDocumentReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_DOCUMENT_LIST':
      return {
        ...state,
        documentList: action.payload,
      };
    case 'ANOTHER_CASE':
      // handle another case
      return state;
    case 'YET_ANOTHER_CASE':
      // handle yet another case
      return state;
    case type.ORDER_GRADING_GROUPS:
      return {
        ...state,
        orderGradingGroups: action.payload,
      };
    case type.GET_SAMPLE_SIZE_NAME:
      return {
        ...state,
        sampleSizeData: action.payload,
      };
    default:
      return state;
  }
};

export default measurmentDocumentReducer;
